// ============================================
// COMPONENT - Encabezado de tabla ordenable por click
// ============================================
// Mismo patrón visual que InventarioPage.tsx (handleSort/renderSortIcon):
// flecha visible en la columna activa, tenue en hover para las demás.

import { MdArrowUpward, MdArrowDownward } from 'react-icons/md';

type SortDirection = 'asc' | 'desc';

interface SortableThProps {
  field: string;
  label: string;
  currentField: string | null;
  currentDirection: SortDirection;
  onSort: (field: string) => void;
  align?: 'left' | 'right' | 'center';
  /** Clase de ancho (ej. "w-[18%]") para usar junto a una tabla `table-fixed` y evitar columnas con espacio muerto. */
  widthClass?: string;
}

export const SortableTh = ({ field, label, currentField, currentDirection, onSort, align = 'left', widthClass = '' }: SortableThProps) => {
  const isActive = currentField === field;
  const alignClass = align === 'right' ? 'justify-end' : align === 'center' ? 'justify-center' : '';
  const textAlignClass = align === 'right' ? 'text-right' : align === 'center' ? 'text-center' : 'text-left';

  return (
    <th
      className={`px-6 py-3 ${textAlignClass} text-sm font-bold text-[#11194F] cursor-pointer hover:bg-gray-200 transition-colors group ${widthClass}`}
      onClick={() => onSort(field)}
    >
      <div className={`flex items-center gap-1 ${alignClass}`}>
        <span>{label}</span>
        {isActive ? (
          currentDirection === 'asc' ? (
            <MdArrowUpward className="text-blue-600" />
          ) : (
            <MdArrowDownward className="text-blue-600" />
          )
        ) : (
          <MdArrowUpward className="text-gray-400 opacity-0 group-hover:opacity-50" />
        )}
      </div>
    </th>
  );
};
